import { IMethod, IPaginated, IPhotoEntityReference, ISides, Mode, PaginationStyle, PictureDisplayMode } from '@gs/shared';
import { ResponsiveAttribute } from '../../../basic/responsive-attribute';
import { GsStructBorderRadius, GsStructComponent, GsStructPageItems, GsStructSwiper } from '../component';

export enum GalleryViewMode {
  Grid = 0,
  Masonry = 1,
  Swiper = 2
}

export interface GsStructGalleryComponent extends GsStructComponent<IGalleryRender>, GsStructSwiper, GsStructPageItems {
  /** The specified type-key for this struct */
  componentType: 'Gallery';
  /** The ID of the gallery to display */
  iD?: string;
  /** Height of the gallery images in pixels (responsive) */
  galleryImageHeight?: ResponsiveAttribute<number | null>;
  /** Show captions on images */
  showCaptions: boolean;
  /** Enable lightbox for images */
  enableLightbox: boolean;
  /** How the items should be shown (list, slider, etc) */
  mode: Mode;
  /** Message to display when gallery is empty */
  emptyMessage?: string;
  /** Border radius for the item images */
  borderRadiusItemImage?: GsStructBorderRadius;
  /** Item padding around each image */
  itemPadding?: ISides;
  /** Enable zoom effect on hover for gallery items */
  itemZoomOnHover: boolean;
  /** Whether to show pagination controls */
  withPagination: boolean;
  /** The style of pagination to use */
  paginationStyle: PaginationStyle;
  /** Overrides the per-photo StretchMode (Auto keeps it; Cut/Full map to object-cover/contain). */
  pictureDisplayMode?: PictureDisplayMode;
}

export interface IGalleryRender {
  gallery: IGallery;
  items: IPaginated<IGalleryItem>;
  methods: IGalleryMethods;
}

export interface IGallery {
  /** The ID of the gallery */
  galleryID: number;
  /** The name of the gallery */
  name: string;
  /** The key of the gallery */
  key: string;
  /** The photos in the gallery */
  photos: IPhotoEntityReference[];
}

export interface IGalleryItem {
  photo: IPhotoEntityReference;
}

export interface IGalleryMethods {
  populate: IMethod;
}
